import { Box } from "@mui/material";

// Painel de conteúdo das três abas do circuito: monta só o conteúdo da aba ativa (não display:none), o que elimina os N canvases React Flow simultâneos. A barra de Tabs visível (Formulário/Anexos/Diagrama de equipamentos) fica fora do Paper do circuito, em serviceItem.js — mesmo lugar/estilo onde ficavam as antigas abas "Circuito 1..N"
export default function CircuitoTabs({ abaAtiva = 0, children = {} }) {
  return (
    <Box>
      {abaAtiva === 0 && children?.formulario}
      {abaAtiva === 1 && children?.anexos}
      {abaAtiva === 2 && children?.diagrama}
    </Box>
  );
}
